// Pure helpers for the field officer directory + traffic waiting identity (demo flow).
// Kept DOM-free so they are unit-testable in the node test env.

// The field side must only ever see online + available officers, so it always queries the
// directory with the available filter; the server applies it (DirectoryFilter, BR-2).
export function officersEndpoint(availableOnly = true): string {
  return availableOnly ? "/officers?available=true" : "/officers";
}

// Label shown on the traffic waiting screen identifying the allocated officer (rank + name
// resolved from the registered session). Falls back to a generic label when unknown.
export function officerWaitingLabel(displayName: string | null | undefined, fallback: string): string {
  const name = (displayName ?? "").trim();
  return name.length > 0 ? name : fallback;
}

// A directory-affecting hub event: when an officer's availability changes the field side
// must refetch its (available-only) directory so it stops showing officers that became
// unavailable and shows officers that came back. Pure + unit-tested; CallFlow uses it to
// bump a reload key handed to PreCall.
export function isPresenceEvent(eventName: string): boolean {
  return eventName === "presenceChanged";
}
